import { apiSlice } from "@app/api/apiSlice";

export const schemeDetailsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadPublicSchemeDetails: builder.query({
      query: (scheme_id) => `scheme/public/${scheme_id}`,
    }),
    placeOrderPublicScheme: builder.mutation({
      query: (body) => ({
        method: "POST",
        url: `order/public`,
        body,
      }),
    }),
    loadPublicOfficeOptions: builder.query({
      query: (vdc_municipality_id) =>
        `office/public?page=1&size=0&find_vdc_municipality=${vdc_municipality_id}&find_type=RETAILER`,
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadPublicSchemeDetailsQuery,
  usePlaceOrderPublicSchemeMutation,
  useLoadPublicOfficeOptionsQuery,
} = schemeDetailsApiSlice;
